module.exports = __webpack_public_path__ + "media/images/menu/monoceros-43067717dbfa88e2293530554db0078a.jpg";